var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 2H3.875V2.75H3.125V5H3.875V5.75H6.125V5H3.875V2.75H6.125V2ZM6.125 2.75H6.875V5H6.125V2.75ZM2 7.25H2.75V8.75H7.25V9.5H2V7.25ZM2.75 7.25H7.25V6.5H2.75V7.25ZM8 7.25H7.25V9.5H8V7.25ZM7.625 2H9.125V2.75H7.625V2ZM9.125 5H7.625V5.75H9.125V5ZM9.125 2.75H9.875V5H9.125V2.75ZM11 7.25H10.25V8.75H8.75V9.5H11V7.25ZM8.75 6.5H10.25V7.25H8.75V6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersS);
export default __webpack_public_path__ + "static/media/users-s.3456432f505c8bd6e838dc76e4b0fa68.svg";
export { ForwardRef as ReactComponent };